export default __webpack_public_path__ + "static/media/upload_icon.74889a36.png";